$(function () {
    var pickerIcons = {
        time: 'fa fa-clock-o',
        date: 'fa fa-calendar',
        up: 'fa fa-arrow-up',
        down: 'fa fa-arrow-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-crosshairs',
        clear: 'fa fa-trash-o',
        close: 'fa fa-times'
    };

    $('[id*="datePicker-"]').datetimepicker({
        format: 'L',
        icons: pickerIcons
    });
    $('[id*="timePicker-"]').datetimepicker({
        format: 'LT',
        icons: pickerIcons
    });
    $('[id*="dateTimePicker-"]').datetimepicker({
        icons: pickerIcons
    });
});
